var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherClearNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8333 33.3333C14.5 33.3333 12.3125 32.8889 10.2708 32C8.22917 31.1111 6.45139 29.9097 4.9375 28.3958C3.42361 26.8819 2.22222 25.1042 1.33333 23.0625C0.444444 21.0208 0 18.8333 0 16.5C0 12.4444 1.29167 8.86806 3.875 5.77083C6.45833 2.67361 9.75 0.75 13.75 0C13.25 2.75 13.4028 5.4375 14.2083 8.0625C15.0139 10.6875 16.4028 12.9861 18.375 14.9583C20.3472 16.9306 22.6458 18.3194 25.2708 19.125C27.8958 19.9306 30.5833 20.0833 33.3333 19.5833C32.6111 23.5833 30.6944 26.875 27.5833 29.4583C24.4722 32.0417 20.8889 33.3333 16.8333 33.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherClearNight);
export default __webpack_public_path__ + "static/media/weather-clear-night.f1a692c11b33a60914cb9c7daada7f97.svg";
export { ForwardRef as ReactComponent };